var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 55.8 53.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 35.89,
    y1: 39.85,
    x2: 19.91,
    y2: 55.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8da2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80c341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 36.1,
    y1: 39.71,
    x2: 19.7,
    y2: 56.11,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 36.41,
    y1: 19.64,
    x2: 19.39,
    y2: 36.67,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 36.62,
    y1: 19.38,
    x2: 19.18,
    y2: 36.82,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 47.62,
    y1: -7.68,
    x2: 8.18,
    y2: 31.77,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 47.87,
    y1: -7.93,
    x2: 7.93,
    y2: 32.02,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 43.36v-1.1a3.1 3.1 0 00-3.1-3.1h-12a3.1 3.1 0 00-3.1 3.1v1.1a1.8 1.8 0 00-1.09 1.47l-.83 7.94 1.29.13L19 45a.49.49 0 01.49-.44h16.84a.5.5 0 01.49.44l.83 7.94 1.29-.13-.83-7.94A1.8 1.8 0 0037 43.36zm-1.3-.14H20.08v-1a1.8 1.8 0 011.8-1.8h12a1.8 1.8 0 011.8 1.8z",
    fill: "url(#a)",
    stroke: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9 11.13L17.69 27.24l4.43 8.85h-1.74a.65.65 0 100 1.3h15a.65.65 0 100-1.3h-1.7l4.43-8.85zM29 29.76a1.06 1.06 0 11-1.1-1.06 1.06 1.06 0 011.1 1.06zm3.27 6.33h-8.7l-4.39-8.77 8.07-12.74v12.93a2.36 2.36 0 101.3 0V14.58l8.07 12.74z",
    fill: "url(#c)",
    stroke: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.55 5.48V.25h-5.23v2H30.51v-2h-5.22v2H5.48v-2H.25v5.23h5.23v-2h14.93A22.3 22.3 0 005.72 22H3.58v5.23h5.23V22H7A21 21 0 0125.29 3.7v1.78h5.22V3.7A21 21 0 0148.77 22H47v5.23h5.23V22h-2.15A22.27 22.27 0 0035.4 3.51h14.92v2zm-3.93-3.93h2.63v2.63h-2.63zM4.18 4.18H1.55V1.55h2.63zm3.33 19.07v2.63H4.88v-2.63zm21.7-19.07h-2.62V1.55h2.62zm21.71 19.07v2.63h-2.63v-2.63z",
    fill: "url(#e)",
    stroke: "url(#f)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.5580a18a84a9cb0e565bafd50d00efee.svg";
export { ForwardRef as ReactComponent };